routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.shoppingExperience', {
      url: __env.routes.shoppingExperience,
      template: `<shopping-experience sh-ctrl="shCtrl" ></shopping-experience>`
    });
}

export default routesConfig;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shopping-experience/shopping-experience.config.js
 **/